var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { observer } from "mobx-react";
import * as T from "sb-resp-ui";
import { RacingRegionSwitcherRoot } from "../RacingRegionSwitcher";
import { RacingCurrentEventsRoot } from "../RacingCurrentEvents";
import { RacingFutureEventsRoot } from "../RacingFutureEvents";
import { RacingNextRacesRoot } from "../RacingNextRaces";
// external components
// import * as CMP from "./components";
// import * as SCMP from "../../components";
/*
    Setup testing tools for MobX
    uncoment the <DevTools /> at the end of the RacingCombinedView component
*/
// import DevTools from "mobx-react-devtools";
// import { setLogEnabled, setUpdatesEnabled, setGraphEnabled } from "mobx-react-devtools";
// if (process.env.NODE_ENV === "development") {
//     setLogEnabled(true);
//     setUpdatesEnabled(true);
//     setGraphEnabled(true);
// }
var RacingCombinedView = /** @class */ (function (_super) {
    __extends(RacingCombinedView, _super);
    function RacingCombinedView(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            tabActive: "current",
            dataProvider: _this.props.dataProvider,
        };
        _this.cachedState = {
            branchId: _this.state.dataProvider.racingStore.branchId,
            regionId: _this.state.dataProvider.racingStore.regionId
        };
        return _this;
        // window["t"] = this;
    }
    /* istanbul ignore next */
    RacingCombinedView.prototype.componentDidMount = function () {
        // setup instances of the blocks
        // activate/deactivate is managed elsewhere
        this.internalBlocks = {
            region: new RacingRegionSwitcherRoot("racing-region-switcher", __assign({}, this.props.options)),
            nextRaces: new RacingNextRacesRoot("racing-next-races", __assign({}, this.props.options)),
            current: new RacingCurrentEventsRoot("racing-current-events", __assign({}, this.props.options), this.props.racingGameBlockNav),
            tomorrow: new RacingCurrentEventsRoot("racing-tomorrow-events", __assign({}, this.props.options), this.props.racingGameBlockNav),
            future: new RacingFutureEventsRoot("racing-future-events", __assign({}, this.props.options))
        };
        // link tabs instances
        this.tabsInstances = {
            current: this.internalBlocks.current,
            tomorrow: this.internalBlocks.tomorrow,
            future: this.internalBlocks.future
        };
        this.activateMain();
    };
    /* istanbul ignore next */
    RacingCombinedView.prototype.activateMain = function () {
        // blocks active when the view first loads
        this.internalBlocks.region.activate();
        if (this.state.dataProvider.racingStore.isNextRacesAvailable) {
            this.internalBlocks.nextRaces.activate();
        }
        else {
            this.internalBlocks.nextRaces.deactivate();
        }
        this.internalBlocks.current.setParams(0);
        this.internalBlocks.current.activate();
        this.internalBlocks.tomorrow.setParams(1);
    };
    /* istanbul ignore next */
    RacingCombinedView.prototype.deactivateAll = function () {
        var _this = this;
        Object.keys(this.internalBlocks).forEach(function (x) {
            typeof _this.internalBlocks[x].deactivate === "function" && _this.internalBlocks[x].deactivate();
        });
    };
    /* istanbul ignore next */
    RacingCombinedView.prototype.componentWillUnmount = function () {
        this.deactivateAll();
    };
    /* istanbul ignore next */
    RacingCombinedView.prototype.callTab = function (tab) {
        var _this = this;
        Object.keys(this.tabsInstances).forEach(function (x) { return _this.tabsInstances[x][x === tab ? "activate" : "deactivate"](); });
        this.setState({ tabActive: tab });
    };
    /* istanbul ignore next */
    RacingCombinedView.prototype.renderTabTrigger = function (text, isDefault, link) {
        var _this = this;
        return (React.createElement("div", { className: "rj-generic-tabs-01-outer", onClick: function () { return _this.callTab(link); } },
            React.createElement(T.TabTrigger, { default: isDefault, link: link },
                React.createElement("a", { className: "rj-generic-tabs-01" }, text))));
    };
    /* istanbul ignore next */
    RacingCombinedView.prototype.renderTabBlock = function (id, link) {
        return (React.createElement(T.TabBlock, { link: link },
            React.createElement("div", { id: id })));
    };
    /* istanbul ignore next */
    RacingCombinedView.prototype.getSnapshotBeforeUpdate = function (prevProps, prevState) {
        if (this.cachedState.branchId !== this.state.dataProvider.racingStore.branchId ||
            this.cachedState.regionId !== this.state.dataProvider.racingStore.regionId) {
            return {
                branchId: this.state.dataProvider.racingStore.branchId,
                regionId: this.state.dataProvider.racingStore.regionId
            };
        }
        /* tslint:disable:no-null-keyword */
        return null;
        /* tslint:enable:no-null-keyword */
    };
    /* istanbul ignore next */
    RacingCombinedView.prototype.componentDidUpdate = function (revProps, prevState, snapshot) {
        if (snapshot !== null) {
            this.deactivateAll();
            this.tabs && this.tabs.resetTabs();
            this.cachedState = snapshot;
        }
        this.activateMain();
    };
    RacingCombinedView.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { "data-combined-active-view": this.state.tabActive, "data-combined-region": this.state.dataProvider.racingStore.regionId },
            React.createElement("div", { id: "racing-region-switcher" }),
            React.createElement("div", { id: "racing-next-races", "data-next-races": this.state.dataProvider.racingStore.isNextRacesAvailable }),
            React.createElement(T.Tabs, { ref: function (n) { return _this.tabs = n; } },
                React.createElement("div", { className: "rj-generic-tabs-01-container" },
                    React.createElement(T.TabsTriggers, null,
                        this.renderTabTrigger(this.props.dict.TodayEvents, true, "current"),
                        this.state.dataProvider.racingStore.isTomorrowEventsPresent &&
                            this.renderTabTrigger(this.props.dict.TomorrowEvents, false, "tomorrow"),
                        this.state.dataProvider.racingStore.isFutureEventsPresent &&
                            this.renderTabTrigger(this.props.dict.AntepostEvents, false, "future"))),
                React.createElement("div", { className: "racing-combined-view__tabs-blocks" },
                    React.createElement(T.TabsBlocks, null,
                        this.renderTabBlock("racing-current-events", "current"),
                        this.renderTabBlock("racing-tomorrow-events", "tomorrow"),
                        this.renderTabBlock("racing-future-events", "future"))))));
    };
    RacingCombinedView = __decorate([
        observer,
        __metadata("design:paramtypes", [Object])
    ], RacingCombinedView);
    return RacingCombinedView;
}(React.Component));
export { RacingCombinedView };
//# sourceMappingURL=RacingCombinedView.js.map